import { Fieldset as BaseFieldset, type FieldsetLegendProps } from '@base-ui/react';

import { clsxs } from '~/styles/utils';

import { fieldLabelStyle } from '../Field/FieldLabel.css';

type Props = FieldsetLegendProps;

export const FieldGroupLegend = ({ ...delegated }: Props) => {
  return <BaseFieldset.Legend {...delegated} className={clsxs(fieldLabelStyle, delegated.className)} />;
};
